export default __webpack_public_path__ + "static/media/web.86e1f359.webp";